// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input_input__EBh3D {
  position: relative;
  width: 100%;
}

.input_inputWrapper__EU-CH {
  height: 50px;
}

.input_input-error__x9qYk label[class^=input_label] {
  top: 18px;
}

.input_label__j-IUX {
  position: absolute;
  z-index: 1;
  left: 16px;
  padding: 0 5px;
  font-size: 0.8rem;
  font-weight: normal;
  line-height: 14px;
  color: gray !important;
  transition: 0.2s ease all;
}
.input_label__j-IUX span {
  margin-left: 5px;
}
.input_label_disabled__yTwuE {
  color: gray !important;
}

.input_success__je5Jk {
  width: 10px;
}
.input_success_container__mLjJ5 {
  position: absolute;
  top: 15px;
  right: 20px;
  pointer-events: none;
}

.input_phone__guuMg {
  position: absolute;
  left: 20px;
  top: 16px;
  color: #34303D;
  background-color: #FFFDFB;
}

.input_label-error__WBxI0 {
  color: #C73636 !important;
}

.input_mask__4L7ch {
  width: calc(100% - 2.8rem);
  padding: 16px;
  color: #34303D;
  border: 1px solid #99979E;
  border-radius: 5px;
  outline: none;
  background-color: #FFFDFB;
}
.input_mask__4L7ch::-webkit-outer-spin-button, .input_mask__4L7ch::-webkit-inner-spin-button {
  margin: 0;
  -webkit-appearance: none;
}
.input_mask__4L7ch[type=number] {
  -moz-appearance: textfield;
}
.input_mask-disabled__N6eUd {
  opacity: 0.5;
}

.input_mask-error__JKAB\\+ {
  border: 2px solid #C73636;
}

.input_disabled__Ob-X1 {
  opacity: 0.5;
}
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .input_disabled__Ob-X1 {
    opacity: 1;
  }
}
@media only screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) {
  .input_disabled__Ob-X1 {
    opacity: 1;
  }
}
@media only screen and (device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) {
  .input_disabled__Ob-X1 {
    opacity: 1;
  }
}

.input_focused__S2vL2 .input_mask__4L7ch {
  border-color: #99979E !important;
  box-shadow: 0 0 0 1px #99979E;
}
.input_focused__S2vL2 .input_label__j-IUX {
  color: #99979E;
}

.input_medium__3CRYx .input_mask__4L7ch {
  width: 100%;
  width: -webkit-fill-available;
  height: -webkit-fill-available;
  padding: 10px 10px 10px 20px;
  box-sizing: content-box;
  -moz-box-sizing: border-box;
  font-size: 16px;
}
.input_medium__3CRYx .input_label__j-IUX {
  top: calc(50% - 0.3rem);
  font-size: 0.8rem;
}
@-moz-document url-prefix() {
  .input_medium__3CRYx .input_label__j-IUX {
    top: calc(40% - 0.3rem);
  }
}
.input_medium__3CRYx .input_error__5VunB {
  /* errors are not absolute tho */
  top: calc(100% + 6px);
  font-size: 12px;
  line-height: normal;
}
.input_medium__3CRYx .input_error-sign__UIh5Q {
  width: 20px;
  height: 20px;
  top: 15px;
  font-size: 12px;
}
.input_medium__3CRYx.input_has-value__I-7uC .input_label__j-IUX, .input_medium__3CRYx.input_focused__S2vL2 .input_label__j-IUX {
  top: -7px;
  left: 12px;
  font-size: 12px;
  color: #99979E !important;
  background-color: #FFF;
}
.input_medium__3CRYx.input_has-value__I-7uC .input_label-error__WBxI0, .input_medium__3CRYx.input_focused__S2vL2 .input_label-error__WBxI0 {
  color: #C73636 !important;
}
.input_medium__3CRYx.input_has-value__I-7uC .input_label_disabled__yTwuE, .input_medium__3CRYx.input_focused__S2vL2 .input_label_disabled__yTwuE {
  z-index: 9 !important;
  color: #99979E !important;
  background-color: #FFF;
}
.input_medium__3CRYx.input_has-value_disable__6Otf4 .input_disabled__Ob-X1, .input_medium__3CRYx.input_focused_disable__XokyZ .input_disabled__Ob-X1 {
  opacity: 1;
}
.input_medium__3CRYx.input_has-value_disable__6Otf4 input, .input_medium__3CRYx.input_focused_disable__XokyZ input {
  border-color: #99979E !important;
}
.input_medium__3CRYx.input_has-value__I-7uC .input_mask__4L7ch, .input_medium__3CRYx.input_focused__S2vL2 .input_mask__4L7ch {
  border-color: #99979E;
}
.input_medium__3CRYx.input_has-value__I-7uC .input_mask-error__JKAB\\+, .input_medium__3CRYx.input_focused__S2vL2 .input_mask-error__JKAB\\+ {
  border: 2px solid #C73636 !important;
  box-shadow: none;
}

.input_large__vJJqu .input_mask__4L7ch {
  height: 58px;
  font-size: 18px;
}
.input_large__vJJqu .input_label__j-IUX {
  top: calc(50% - 0.4rem);
  font-size: 0.8rem;
}
.input_large__vJJqu .input_error__5VunB {
  top: calc(100% + 7px);
  font-size: 14px;
}
.input_large__vJJqu .input_error-sign__UIh5Q {
  width: 24px;
  height: 24px;
  top: calc(50% - 12px);
  font-size: 16px;
}
.input_large__vJJqu.input_has-value__I-7uC .input_label__j-IUX, .input_large__vJJqu.input_focused__S2vL2 .input_label__j-IUX {
  top: -7px;
  left: 12px;
  font-size: 14px;
  color: #99979E !important;
  background-color: #FFF;
}
.input_large__vJJqu.input_has-value__I-7uC .input_mask__4L7ch, .input_large__vJJqu.input_focused__S2vL2 .input_mask__4L7ch {
  border-color: #99979E;
}

.input_error__5VunB {
  display: block;
  color: #C73636;
}

.input_error-sign__UIh5Q {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 20px;
  color: #fff;
  background-color: #C73636;
  border-radius: 100px;
}

.input_suggestions__vGkz4 {
  position: absolute;
  z-index: 50;
  top: calc(100% - 12px);
  left: -1px;
  width: calc(100% + 2px);
  max-height: 180px;
  padding-top: 16px;
  overflow-y: auto;
  background: #fff;
  border: thin solid #99979E;
  border-top: none;
  border-radius: 0 0 16px 16px;
}
.input_suggestions__vGkz4 > *:last-child {
  border-radius: 0 0 16px 16px;
}

.input_suggestion__wMGOm {
  padding: 16px 22px;
  font-size: 14px;
  background: #fff;
  transition: 0.25s;
  cursor: pointer;
}
.input_suggestion__wMGOm:hover {
  background: #eee;
}`, "",{"version":3,"sources":["webpack://./src/components/input/input.module.scss","webpack://./src/styles/common/variables.scss","webpack://./src/styles/common/mixins.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,WAAA;AADF;;AAKA;EACE,YAAA;AAFF;;AAME;EACE,SAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AAJF;AAME;EACE,gBAAA;AAJJ;AAOE;EACE,sBAAA;AALJ;;AASA;EAQE,WAAA;AAbF;AAME;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,oBAAA;AAJJ;;AAUA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,yBAAA;AAPF;;AAUA;EACE,yBAAA;AAPF;;AAUA;EACE,0BAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;EACA,kBCPc;EDQd,aAAA;EACA,yBAAA;AAPF;AASE;EAEE,SAAA;EACA,wBAAA;AARJ;AAWE;EACE,0BAAA;AATJ;AAYE;EACE,YAAA;AAVJ;;AAcA;EACE,yBAAA;AAXF;;AAeA;EACE,YAAA;AAZF;AAcE;EAHF;IAII,UAAA;EAXF;AACF;AAaE;EAPF;IAQI,UAAA;EAVF;AACF;AAYE;EAXF;IAYI,UAAA;EATF;AACF;;AAcE;EACE,gCAAA;EACA,6BAAA;AAXJ;AAcE;EACE,cAAA;AAZJ;;AAkBE;EACE,WAAA;EACA,6BAAA;EACA,8BAAA;EACA,4BAAA;EACA,uBAAA;EACA,2BAAA;EACA,eAAA;AAfJ;AAkBE;EACE,uBAAA;EACA,iBAAA;AAhBJ;AAkBI;EAJF;IAKI,uBAAA;EAfJ;AACF;AAkBE;EACE,gCAAA;EACA,qBAAA;EAEA,eAAA;EACA,mBAAA;AAjBJ;AAoBE;EExIA,WFyIgB;EExIhB,YFwIgB;EAEd,SAAA;EACA,eAAA;AAlBJ;AAuBI;EACE,SAAA;EAEA,UAAA;EAEA,eAAA;EAEA,yBAAA;EAEA,sBAAA;AAzBN;AA2BM;EACE,yBAAA;AAzBR;AA4BM;EACE,qBAAA;EAEA,yBAAA;EAEA,sBAAA;AA5BR;AAiCM;EACE,UAAA;AA/BR;AAkCM;EACE,gCAAA;AAhCR;AAoCI;EACE,qBAAA;AAlCN;AAqCI;EACE,oCAAA;EAEA,gBAAA;AApCN;;AA0CE;EACE,YAAA;EACA,eAAA;AAvCJ;AA0CE;EACE,uBAAA;EACA,iBAAA;AAxCJ;AA2CE;EACE,qBAAA;EACA,eAAA;AAzCJ;AA4CE;EE/MA,WFgNgB;EE/MhB,YF+MgB;EAEd,qBAAA;EACA,eAAA;AA1CJ;AA+CI;EACE,SAAA;EACA,UAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;AA7CN;AAgDI;EACE,qBAAA;AA9CN;;AAoDA;EAGE,cAAA;EAEA,cAAA;AApDF;;AAuDA;EEzPE,aAAA;EAEA,mBAH4D;EAK5D,uBFsPc;EEpPd,mBFoPsB;EAEtB,kBAAA;EACA,WAAA;EAEA,WC/PM;EDgQN,yBAAA;EACA,oBAAA;AAnDF;;AA2DA;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,UAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,4BAAA;AAxDF;AA2DI;EACE,4BAAA;AAzDN;;AA8DA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AA3DF;AA6DE;EACE,gBAAA;AA3DJ","sourcesContent":["@import 'src/styles/core';\n\n.input {\n  position: relative;\n  width: 100%;\n  // border: 2px solid #FFF;\n}\n\n.inputWrapper {\n  height: 50px;\n}\n\n.input-error {\n  label[class^='input_label'] {\n    top: 18px;\n  }\n}\n\n.label {\n  position: absolute;\n  z-index: 1;\n  left: 16px;\n  padding: 0 5px;\n  font-size: 0.8rem;\n  font-weight: normal;\n  line-height: 14px;\n  color: gray !important;\n  transition: $transition ease all;\n\n  span {\n    margin-left: 5px;\n  }\n\n  &_disabled {\n    color: gray !important;\n  }\n}\n\n.success {\n  &_container {\n    position: absolute;\n    top: 15px;\n    right: 20px;\n    pointer-events: none;\n  }\n\n  width: 10px;\n}\n\n.phone {\n  position: absolute;\n  left: 20px;\n  top: 16px;\n  color: #34303D;\n  background-color: #FFFDFB;\n}\n\n.label-error {\n  color: #C73636 !important;\n}\n\n.mask {\n  width: calc(100% - 2.8rem);\n  padding: 16px;\n  color: #34303D;\n  border: 1px solid #99979E;\n  border-radius: $border-radius;\n  outline: none;\n  background-color: #FFFDFB;\n\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    margin: 0;\n    -webkit-appearance: none;\n  }\n\n  &[type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  &-disabled {\n    opacity: 0.5;\n  }\n}\n\n.mask-error {\n  border: 2px solid #C73636;\n}\n\n// Input disabled\n.disabled {\n  opacity: 0.5;\n\n  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {\n    opacity: 1;\n  }\n\n  @media only screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) {\n    opacity: 1;\n  }\n\n  @media only screen and (device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) {\n    opacity: 1;\n  }\n}\n\n// Input focused\n.focused {\n  .mask {\n    border-color: #99979E !important;\n    box-shadow: 0 0 0 1px #99979E;\n  }\n\n  .label {\n    color: #99979E;\n  }\n}\n\n// Input sizes\n.medium {\n  .mask {\n    width: 100%;\n    width: -webkit-fill-available;\n    height: -webkit-fill-available;\n    padding: 10px 10px 10px 20px;\n    box-sizing: content-box;\n    -moz-box-sizing: border-box;\n    font-size: 16px;\n  }\n\n  .label {\n    top: calc(50% - 0.3rem);\n    font-size: 0.8rem;\n\n    @-moz-document url-prefix() {\n      top: calc(40% - 0.3rem);\n    }\n  }\n\n  .error {\n    /* errors are not absolute tho */\n    top: calc(100% + 6px);\n    // margin-top: 5px;\n    font-size: 12px;\n    line-height: normal;\n  }\n\n  .error-sign {\n    @include size(20px);\n\n    top: 15px;\n    font-size: 12px;\n  }\n\n  &.has-value,\n  &.focused {\n    .label {\n      top: -7px;\n\n      left: 12px;\n\n      font-size: 12px;\n\n      color: #99979E !important;\n\n      background-color: #FFF;\n\n      &-error {\n        color: #C73636 !important;\n      }\n\n      &_disabled {\n        z-index: 9 !important;\n\n        color: #99979E !important;\n\n        background-color: #FFF;\n      }\n    }\n\n    &_disable {\n      .disabled {\n        opacity: 1;\n      }\n\n      input {\n        border-color: #99979E !important;\n      }\n    }\n\n    .mask {\n      border-color: #99979E;\n    }\n\n    .mask-error {\n      border: 2px solid #C73636 !important;\n\n      box-shadow: none;\n    }\n  }\n}\n\n.large {\n  .mask {\n    height: 58px;\n    font-size: 18px;\n  }\n\n  .label {\n    top: calc(50% - 0.4rem);\n    font-size: 0.8rem;\n  }\n\n  .error {\n    top: calc(100% + 7px);\n    font-size: 14px;\n  }\n\n  .error-sign {\n    @include size(24px);\n\n    top: calc(50% - 12px);\n    font-size: 16px;\n  }\n\n  &.has-value,\n  &.focused {\n    .label {\n      top: -7px;\n      left: 12px;\n      font-size: 14px;\n      color: #99979E !important;\n      background-color: #FFF;\n    }\n\n    .mask {\n      border-color: #99979E;\n    }\n  }\n}\n\n// Error\n.error {\n  // position: absolute;\n  // left: 15px;\n  display: block;\n  // margin-top: 4px;\n  color: #C73636;\n}\n\n.error-sign {\n  @include flex(center, center);\n\n  position: absolute;\n  right: 20px;\n\n  color: $white;\n  background-color: #C73636;\n  border-radius: 100px;\n\n  // @media (max-width: 425px) {\n  //   top: -58px;\n  //   left: 275px;\n  // }\n}\n\n.suggestions {\n  position: absolute;\n  z-index: 50;\n  top: calc(100% - 12px);\n  left: -1px;\n  width: calc(100% + 2px);\n  max-height: 180px;\n  padding-top: 16px;\n  overflow-y: auto;\n  background: #fff;\n  border: thin solid #99979E;\n  border-top: none;\n  border-radius: 0 0 16px 16px;\n\n  &>* {\n    &:last-child {\n      border-radius: 0 0 16px 16px;\n    }\n  }\n}\n\n.suggestion {\n  padding: 16px 22px;\n  font-size: 14px;\n  background: #fff;\n  transition: 0.25s;\n  cursor: pointer;\n\n  &:hover {\n    background: #eee;\n  }\n}","// white colors\n$white: #fff;\n$white-50: #f4f4f4;\n$white-75: #f6f6f6;\n$white-100: #e1e0e2;\n$white-125: #f2ede9;\n$white-175: #f5f4f2;\n$white-200: #f0eeed;\n$white-225: #f6f4f0;\n$milk-white: #fffdfb;\n$white-smoke: #f6f4f0;\n$white-smoke-100: #8b8890;\n$catskill-white: #f5f5f7;\n\n// grey colors\n$grey-600: rgba(255, 255, 255, 0.6);\n$grey-650: rgba(255, 255, 255, 0.65);\n$grey-700: rgba(255, 255, 255, 0.7);\n$grey-800: #c4c4c4;\n$grey-900: #e2dccf;\n$grey-950: #e5e5e5;\n$grey-cloud: #b8b7bb;\n$dusty-grey: #99979e;\n$medium-grey: #7b7881;\n$vampire-grey: #524f5a;\n$charcoal-grey: #404040;\n$dark-grey: #34303d;\n$dark: #27242d;\n$graphite: #150d04;\n$black: #000;\n$black-50: #1c1a20;\n\n// red colors\n$persian-red: #db3826;\n$reddish: #c73636;\n\n// other colors\n$ultramarine-blue: #307bf6;\n$aqua-blue: #00d1d2;\n$aqua-blue-50: #19a9aa;\n$dusty-orange: #e3813a;\n$gold: #ccb99a;\n$blue: #345ab0;\n$blue-50: #33a8eb;\n$text: #34303d;\n$orange: #ddb162;\n\n$purple: #6969dd;\n$red-50: #991717;\n\n//green\n$green-50: #57760c;\n\n//blue\n$blue-50: #26b1ff;\n$blue-100: #1253a1;\n\n// Other\n$transition: 0.2s;\n$border-radius: 5px;","@mixin flex($justify: flex-start, $align: center, $direction: row) {\n  display: flex;\n\n  flex-direction: $direction;\n\n  justify-content: $justify;\n\n  align-items: $align;\n}\n\n@mixin size($size) {\n  width: $size;\n  height: $size;\n}\n\n@mixin min-size($size) {\n  min-width: $size;\n  min-height: $size;\n}\n\n@mixin force-size($size) {\n  @include size($size);\n  @include min-size($size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `input_input__EBh3D`,
	"inputWrapper": `input_inputWrapper__EU-CH`,
	"input-error": `input_input-error__x9qYk`,
	"label": `input_label__j-IUX`,
	"label_disabled": `input_label_disabled__yTwuE`,
	"success": `input_success__je5Jk`,
	"success_container": `input_success_container__mLjJ5`,
	"phone": `input_phone__guuMg`,
	"label-error": `input_label-error__WBxI0`,
	"mask": `input_mask__4L7ch`,
	"mask-disabled": `input_mask-disabled__N6eUd`,
	"mask-error": `input_mask-error__JKAB+`,
	"disabled": `input_disabled__Ob-X1`,
	"focused": `input_focused__S2vL2`,
	"medium": `input_medium__3CRYx`,
	"error": `input_error__5VunB`,
	"error-sign": `input_error-sign__UIh5Q`,
	"has-value": `input_has-value__I-7uC`,
	"has-value_disable": `input_has-value_disable__6Otf4`,
	"focused_disable": `input_focused_disable__XokyZ`,
	"large": `input_large__vJJqu`,
	"suggestions": `input_suggestions__vGkz4`,
	"suggestion": `input_suggestion__wMGOm`
};
export default ___CSS_LOADER_EXPORT___;
